import { TriggerFunnelInterface } from 'modules/automation-rules/triggers/types/automation-rule-trigger-interface'

export const getTriggerBadgeTexts = (target: TriggerFunnelInterface) => {
  switch (true) {
    case Boolean(target.checkBoxId): {
      return {
        badgeText: 'dashboard.automation_rule.trigger_badge_checkbox',
        tooltipText: 'dashboard.automation_rule.trigger_badge_checkbox_tooltip',
        id: target.checkBoxId,
      }
    }
    case Boolean(target.buttonId): {
      return {
        badgeText: 'dashboard.automation_rule.trigger_badge_button',
        tooltipText: 'dashboard.automation_rule.trigger_badge_button_tooltip',
        id: target.buttonId,
      }
    }
  }
}
